var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLocat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.187,
    height: 22.52,
    viewBox: "0 0 16.187 22.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_52",
    "data-name": "Grupo 52",
    transform: "translate(-919 -184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_336",
    "data-name": "Trazado 336",
    d: "M939.63,201.815a2.815,2.815,0,1,0-2.815,2.815A2.818,2.818,0,0,0,939.63,201.815Zm-4.223,0a1.408,1.408,0,1,1,1.407,1.408A1.409,1.409,0,0,1,935.408,201.815Z",
    transform: "translate(-9.722 -9.722)",
    fill: "#e5bda0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_337",
    "data-name": "Trazado 337",
    d: "M927.081,206.52a.7.7,0,0,0,.528-.238c.31-.352,7.6-8.685,7.577-14.18a8.093,8.093,0,1,0-16.187,0c0,5.492,7.244,13.823,7.552,14.175A.7.7,0,0,0,927.081,206.52Zm.012-21.113a6.723,6.723,0,0,1,6.686,6.7c.019,4.161-5.025,10.6-6.7,12.617-1.663-2.019-6.675-8.455-6.675-12.62A6.7,6.7,0,0,1,927.093,185.408Z",
    fill: "#e5bda0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocat);
export default __webpack_public_path__ + "static/media/icon-locat.d1394d8b0dfc18430c0e04bc8f5e5b07.svg";
export { ForwardRef as ReactComponent };